export const otpRegex = /^(0|[0-1]*)$/;
export const smsRegex = /(\d{6})/g;
